import { ChatMessageType } from "../contracts";
import { isRecord } from "../utils/objectValueConversion";
import type { ChatMessageViewModel } from "./chatMessageViewModel";

export type AgentRequest = {
    tool_call: {
        type: "tool_use";
        id: string;
    };
};

export const isAgentRequest = (type: ChatMessageType, payload: unknown): payload is AgentRequest => {
    if (!isRecord(payload) || type !== ChatMessageType.AgentRequest) {
        return false;
    }

    const toolCall = payload.tool_call;

    if (!isRecord(toolCall)) {
        return false;
    }

    return (
        toolCall.type === "tool_use"
        && typeof toolCall.id === "string"
        && "tool_call_user_selection" in payload
    );
};

export const getAgentRequestById = <TToolResponse extends AgentRequest = AgentRequest>(
    messages: ChatMessageViewModel[] | undefined,
    toolRequestId: string
): TToolResponse | undefined => {
    if (!messages) {
        return undefined;
    }

    for (const message of messages) {
        const payload = message.payload;

        if (isAgentRequest(message.type, payload) && payload.tool_call.id === toolRequestId) {
            return payload as TToolResponse;
        }
    }

    return undefined;
};

export const isCommercialSimulatorSubBrandAgentRequest = (
    type: ChatMessageType,
    action: string | null | undefined,
    payload: unknown
): payload is AgentRequest => {
    return (
        isAgentRequest(type, payload)
        && action === "commercial_simulator_sub_brand"
    );
};

export const isCommercialSimulatorAgentRequest = (
    type: ChatMessageType,
    action: string | null | undefined,
    payload: unknown
): payload is AgentRequest => {
    return (
        isAgentRequest(type, payload)
        && action === "commercial_simulator_sku"
    );
};

export const isSimulatorAgentRequest = (
    type: ChatMessageType,
    action: string | null | undefined,
    payload: unknown
): payload is AgentRequest => {
    return (
        isCommercialSimulatorAgentRequest(type, action, payload)
        || isCommercialSimulatorSubBrandAgentRequest(type, action, payload)
    );
};
